import LogsFilters from './LogsFilters';

export default LogsFilters;
